import { useState } from 'react';

import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

export function useLockBodyScroll(lock: boolean, scrollToTop = false) {
  const [originalStyle, setOriginalStyle] = useState<{
    bodyHeight: string;
    bodyPosition: string;
    bodyWidth: string;
    htmlHeight: string;
    htmlOverflow: string;
  } | null>();

  useIsomorphicLayoutEffect(() => {
    if (lock) {
      document.body.style.overflow = 'hidden';
      if (scrollToTop) {
        setOriginalStyle({
          bodyPosition: document.body.style.position,
          bodyHeight: document.body.style.height,
          bodyWidth: document.body.style.width,
          htmlOverflow: document.documentElement.style.overflow,
          htmlHeight: document.documentElement.style.height,
        });
        document.body.style.position = 'fixed';
        document.body.style.height = '100vh';
        document.body.style.width = '100%';
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.height = '100vh';
      }
    } else {
      document.body.style.overflow = 'auto';
      if (scrollToTop && originalStyle) {
        document.body.style.position = originalStyle.bodyPosition;
        document.body.style.height = originalStyle.bodyHeight;
        document.body.style.width = originalStyle.bodyWidth;
        document.documentElement.style.overflow = originalStyle.htmlOverflow;
        document.documentElement.style.height = originalStyle.htmlHeight;
        setOriginalStyle(null);
      }
    }

    return () => {
      document.body.style.overflow = 'auto';
      if (originalStyle) {
        document.body.style.position = originalStyle.bodyPosition;
        document.body.style.height = originalStyle.bodyHeight;
        document.body.style.width = originalStyle.bodyWidth;
        document.documentElement.style.overflow = originalStyle.htmlOverflow;
        document.documentElement.style.height = originalStyle.htmlHeight;
      }
    };
  }, [lock]);
}
